import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'op-formattable-textarea-input',
  templateUrl: './formattable-textarea-input.component.html',
  styleUrls: ['./formattable-textarea-input.component.scss'],
})
export class FormattableTextareaInputComponent extends FieldType {
}
